<template>
  <b-avatar class="avatar" :variant="variant" :src="'https://vapor-us-east-1-1603342423.s3.amazonaws.com/' + avatar" v-if="useAvatar" :size="size"></b-avatar>
  <b-avatar class="avatar" :variant="variant" :text="initials(name)" :size="size" v-else></b-avatar>
</template>

<script>
export default {
  props: {
    name: null,
    avatar: null,
    size: null,
    border: null,
    variant: null
  },
  computed: {
    useAvatar() {
      return this.avatar && this.avatar !== 'users/default.png';
    }
  },
  methods: {
    initials() {
      let initials = this.name.split(" ");

      if (initials.length > 1) {
        return initials[0].charAt(0) + initials[1].charAt(0);
      }

      return initials[0].charAt(0);
    }
  }
};
</script>
<style lang="scss">
.text-gold {
  color: #FACA27;
}
.border-gold {
  border: 5px solid #FACA27 !important;
}
.text-silver {
  color: #F4F5F6;
}
.border-silver {
  border: 5px solid #F4F5F6 !important;
}
.text-bronze {
  color: #ED9A56;
}
.border-bronze {
  border: 5px solid #ED9A56 !important;
}
.avatar .rounded-circle, .b-avatar-img {
  border-radius: 50% !important;
}
</style>